const getDefaultState = () => ({
    team: {
      team_name: "",
      description: "",
      country: "",
      region: "",
      district: "",
      team_coordinator: null,
      trainers: [],
      trainer_names: [],
      coordinator_name: "",
      active: true,
      start_date: null,
      end_date: null
    },
    clusterTeamsIds: []
  });

  const cluster = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
      team_name(state, val) {
        state.team.team_name = val;
      },
      description(state, val) {
        state.team.description = val;
      },
      country(state, val) {
        state.team.country = val;
      },
      region(state, val) {
        state.team.region = val;
      },
      district(state, val) {
        state.team.district = val;
      },
      addClusterTeamsIds(state, val) {
        state.clusterTeamsIds.push(val);
      },
      removeClusterTeamIds(state,val){
        state.clusterTeamsIds.splice(val,1);
      },
      teams(state, val) {
        state.teams = val;
      },
      resetTeams(state) {
        Object.assign(state, getDefaultState());
      }
    },
    actions: {
      async GET_TEAMS({ commit }) {
        const res = await TeamService.fetchTeams();
        const data = res.data.results;
        commit("teams", data);
      },
      ADD_TEAM_ID(context,val){
        context.commit("addClusterTeamsIds",val);
      },
      REMOVE_TEAM_ID(context,val){
        context.commit("removeClusterTeamIds",val);
      },
      async RESET_TEAMS_STATE(context) {
        await context.commit("resetTeams");
      }
    },
    getters: {
        getTeamIds: (state) => state.clusterTeamsIds,
    }
  };
  
  export default cluster;